import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import '../../style/UserHeader.css';
import {
  Container,
  Typography,
} from '@mui/material';
import { Hostage, UserTab } from "../types";
import {useTranslation} from 'react-i18next';
import TitlebarImageList from "../TitlebarImageList";
import { useUser } from '../../context/UserContext';
import { decode } from '../../utils/Utils';

interface UserHeaderProps {
  userHostages: Hostage[];
  setTabValue: (value: UserTab) => void;
}

const UserHeader: React.FC<UserHeaderProps> = ({ userHostages, setTabValue }) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const { user } = useUser();

  const handleItemClick = (id: string) => {
    navigate(`/hostage/${id}`);
  };

  const handleMoreHostagesClick = () => {
    setTabValue("Hostages");
  }

  return (
      <Container>
        <div>
          <Typography
              variant="h4"
              component="h1"
              className='user-home-title'>
            {decode(t('userHome.title', {username: user?.first_name}))}
          </Typography>
          <Typography
              variant="subtitle1"
              component="h2"
              className='user-home-subtitle'>
            {t('userHome.subtitle')}
          </Typography>
        </div>
        {user?.supported_hostages && user.supported_hostages.length > 0 && <div>
          <Typography
              variant="subtitle1"
              component="h2"
              className='user-home-subtitle'>
            {t('userHome.hostagesListTile')}
          </Typography>
          <TitlebarImageList
              hostages={userHostages}
              onItemClick={handleItemClick}
              onMoreHostagesClick = {handleMoreHostagesClick}
              horizontalScroll={true}
          />
        </div>}
    </Container>
  );
};

export default UserHeader;
